/* eslint-disable */

export const alertStatus = {
  Success: 'success',
  Fail: 'fail',
  Warn: 'warn',
};
